// ======================================================================
// File Name       : tabMenu
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as actionType from '../constants/actionTypes/tabMenu';

const initialState = {
  activeTab: null,
  activeReportTab: null,
};

export default function page(state = initialState, action) {
  switch (action.type) {
    case actionType.TABMENU_SAVE_ACTIVE_TAB: {
      const { key } = action;
      return {
        ...state,
        activeTab: key,
      };
    }

    case actionType.REPORT_TABMENU_SAVE_ACTIVE_TAB: {
      const { key } = action;
      return {
        ...state,
        activeReportTab: key,
      };
    }

    default:
      return state;
  }
}
